import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { useJourneyNavigate } from '@/services/journeys/useJourneyNavigate';

import { useValidateTransactionPending } from './useValidateTransactionPending';
import { clearErrorMessage } from './transactionSlice';
import { PaymentSelectState } from '@/features/paymentSelect/paymentSelectSlice';

// Components
import PaymentErrorText from './PaymentErrorText';
import {
  ColouredBackground, StyledHeading, StyledButton, StyledText
} from './PaymentStyles.style';

function PaymentFailure() {
  const dispatch = useAppDispatch();
  const { provider } = useAppSelector((state: { paymentSelect: PaymentSelectState }) => state.paymentSelect);

  const journeyNavigate = useJourneyNavigate();

  // Validate state is as expected, otherwise redirect to index
  useValidateTransactionPending();

  const retryPayment = () => {
    dispatch(clearErrorMessage());
    if (provider === 'BRAINTREE_GOOGLEPAY' || provider === 'BRAINTREE_APPLEPAY' || provider === 'PAYPAL') {
      journeyNavigate('return-to-payment-select');
    } else {
      journeyNavigate('retry');
    }
  };

  return (
    <ColouredBackground>

      <StyledHeading tag="h1" family="Anton" size="xl" color="black" uppercase>Payment Failure</StyledHeading>

      <PaymentErrorText />

      <StyledText tag="p" family="Montserrat" size="md" color="black">
        The payment didn’t go through and you haven&apos;t been charged.
      </StyledText>

      <StyledButton
        type="submit"
        onClick={retryPayment}
      >
        Try again
      </StyledButton>

    </ColouredBackground>
  );
}

export default PaymentFailure;
